import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-sand text-ink2">
        Checking session…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
};

export default ProtectedRoute;
